/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const alignJustifyAlt = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path
			clipRule="evenodd"
			fillRule="evenodd"
			d="M4 5h16v2H4V5zm0 4v2h16V9H4zm0 4h16v2H4v-2zm16 6H4v-2h16v2z"
		/>
	</SVG>
);

export default alignJustifyAlt;
